var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoUserInfoProfileThumb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26 14c0 6.628-5.373 12-12 12-6.628 0-12-5.372-12-12C2 7.373 7.372 2 14 2c6.627 0 12 5.373 12 12",
    fill: "#E5E9EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 16.685a9.658 9.658 0 0 0-8.318 4.745 11.26 11.26 0 0 0 2.132 1.855l.406.258.215.127.278.156.2.105.314.155.452.202.42.168.211.074c.102.036.204.072.308.105l.533.155.31.075.238.055.175.035.387.069.192.027.38.048.58.046a11.236 11.236 0 0 0 1.173 0l.157-.012c.142-.01.283-.02.424-.034l.38-.048.297-.046.456-.085.24-.055c.103-.024.206-.048.308-.075l.534-.155.517-.18.422-.167.267-.117.295-.138.204-.102.259-.137.219-.123.22-.13a11.258 11.258 0 0 0 2.533-2.111A9.66 9.66 0 0 0 14 16.685zM14 5.168a4.925 4.925 0 0 1 4.92 4.919 4.925 4.925 0 0 1-4.92 4.92 4.925 4.925 0 0 1-4.92-4.92A4.925 4.925 0 0 1 14 5.167z",
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoUserInfoProfileThumb);
export default __webpack_public_path__ + "static/media/ico-user-info-profile-thumb.243dccc64f3cc7a5db1ed1875100a02d.svg";
export { ForwardRef as ReactComponent };